import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ded73df6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute w-full bg-banner !h-[20vh]" }, null, -1))
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "text-2xl font-bold text-accent" }
const _hoisted_4 = { class: "w-2/3 mt-4 opacity-70" }

import { onMounted, onUnmounted, ref } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'BannerOverview',
  props: {
		title: {
			type: String,
			default: "Title not defined",
		},
		subTitle: {
			type: String,
			default: "SubTitle not defined",
		},
	},
  setup(__props) {

	const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_CardWidget = _resolveComponent("CardWidget")!

  return (_openBlock(), _createBlock(_component_CardWidget, {
    class: "!h-[20vh] relative flex flex-col",
    cursorPointer: false
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(props.title), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.subTitle), 1)
      ])
    ]),
    _: 1
  }))
}
}

})